import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TEMPLATES_URL } from './helpers';
import {
  IDocumentAssemblerTemplateListResponse,
  TDocumentAssemblerListTemplatesParams,
} from './types';

export const useDocumentAssemblerTemplates = (
  options?: TDocumentAssemblerListTemplatesParams & { enabled?: boolean }
) => {
  const query = new URLSearchParams();
  if (options?.key) query.append('key', options.key);
  if (options?.categoryKey) query.append('categoryKey', options.categoryKey);
  if (options?.includeArchived) query.append('includeArchived', 'true');

  const search = query.toString();
  const isEnabled = options?.enabled ?? true;

  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerTemplateListResponse>(
      isEnabled ? `${TEMPLATES_URL}${search ? `?${search}` : ''}` : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    templates: data?.templates,
    count: data?.count,
    error,
    isLoading,
    mutate,
  };
};
